import { Link } from "react-router-dom";

import { isDevelop } from "../../helpers/apiHelper";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

function NavbarLogo({
  withEnvIndicator,
  style,
}: {
  withEnvIndicator?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div className="flex shrink-0 items-center gap-3" style={style}>
      <Link
        aria-label="Pagina principală"
        className="rounded-control text-inherit no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        to="/">
        <img
          height={50}
          width={50}
          src={toAbsoluteUrl("/logo.svg")}
          className="block h-[40px] w-[40px] sm:h-[50px] sm:w-[50px]"
          alt="TMS"
        />
      </Link>
      {withEnvIndicator && isDevelop && (
        <span className="hidden rounded-control bg-accent-subtle px-3 py-1 text-[12px] font-semibold text-accent lg:block">
          Develop
        </span>
      )}
    </div>
  );
}

export default NavbarLogo;
